import { connect } from "react-redux";
import InlineLoading from "../../../../../components/Loading/Loading";
import MonthlyBalanceSheetReport from "../../../../../models/financials/MonthlyBalanceSheetReport";
import BVASelect from "../../../../../components/BVASelect/BVASelect";
import { useState } from "react";
import MonthlyBalanceSheetConsolidation from "./MonthlyBalanceSheetConsolidation";
import YearlyBalanceSheetConsolidation from "./YearlyBalanceSheetConsolidation";

const MONTHLY_VISUALIZATION_OTPION = "MONTHLY_VISUALIZATION_OTPION";
const YEARLY_VISUALIZATION_OTPION = "YEARLY_VISUALIZATION_OTPION";

const visualizationOptions = [
  { label: "Monthly", value: MONTHLY_VISUALIZATION_OTPION },
  { label: "Yearly", value: YEARLY_VISUALIZATION_OTPION },
];

function BalanceSheetConsolidation({ currentCompanyMonthlyBalanceSheet }) {
  const [selectedVisualization, setSelectedVisualization] = useState(
    MONTHLY_VISUALIZATION_OTPION
  );

  if (!(currentCompanyMonthlyBalanceSheet instanceof MonthlyBalanceSheetReport)) {
    return <InlineLoading />;
  }

  return (
    <div className="pb-10">
      <div className="flex items-center">
        <h2 className="text-xl font-bold">Balance Sheet Consolidation</h2>
        <div className="ml-4">
          <BVASelect
            items={visualizationOptions}
            value={selectedVisualization}
            onChange={(visualiation) => setSelectedVisualization(visualiation)}
          />
        </div>
      </div>
      {selectedVisualization === MONTHLY_VISUALIZATION_OTPION ? (
        <MonthlyBalanceSheetConsolidation />
      ) : (
        <YearlyBalanceSheetConsolidation />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyMonthlyBalanceSheet:
    state.financials.currentCompanyMonthlyBalanceSheet,
});

export default connect(mapStateToProps)(BalanceSheetConsolidation);
